import {ApiServerAlert} from "../../components/Alert/utils";
import {ThresholdComparator} from "./model";
import {dashboardJsonReplacer} from "../../components/Dashboarding/Dashboard";
import {MultiMetoroMetricsChartProps} from "../../components/Charts/MultiMetoroMetricsCharts";

export const timeAggregations = ["p50", "p90", "p95", "p99"]
export const nanoToMilliSeconds = 1_000_000
function checkIsTime(alert: ApiServerAlert) {
    if (alert && alert?.type == "Trace" && alert?.traceAlert) {
        const aggregation = alert?.traceAlert.filters.aggregation
        return timeAggregations.includes(aggregation?.toLowerCase())
    }

    if (alert && alert?.type == "MultiMetric" && alert?.multiMetricAlert
        && alert?.multiMetricAlert.filters.metricSpecifiers.length == 1
        && alert?.multiMetricAlert.filters.metricSpecifiers[0].metricType == "trace") {
        const aggregation = alert?.multiMetricAlert.filters.metricSpecifiers[0].aggregation
        return timeAggregations.includes(aggregation?.toLowerCase())
    }
    return false
}

function getThresholdComparatorSymbol(comparator: ThresholdComparator) {
    if (comparator === ThresholdComparator.GreaterThan) {
        return ">"
    }
    if (comparator === ThresholdComparator.LessThan) {
        return "<"
    }
    if (comparator === ThresholdComparator.GreaterThanOrEqual) {
        return ">="
    }
    if (comparator === ThresholdComparator.LessThanOrEqual) {
        return "<="
    }
    return "?"
}

function createAlertUrlFromAlert(alert: ApiServerAlert): string {
    return "/new-alert?alertJson=" + encodeURIComponent(JSON.stringify(alert, dashboardJsonReplacer));
}

function createMetricExplorerUrlFromMetricChartProps(props: MultiMetoroMetricsChartProps): string {
    return "/metric-explorer?chart=" + encodeURIComponent(JSON.stringify(props, dashboardJsonReplacer));
}

export {checkIsTime, getThresholdComparatorSymbol, createAlertUrlFromAlert, createMetricExplorerUrlFromMetricChartProps}